var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "page-break-item",
        "form-item",
        "align-" + (_vm.align || "center"),
        { selected: _vm.isSelected },
      ],
      on: {
        click: function ($event) {
          return _vm.$emit("select-item", _vm.item)
        },
      },
    },
    [
      _c(
        "div",
        { class: ["navigation-buttons", "justify-" + (_vm.align || "center")] },
        [
          _vm.showPreviousButton
            ? _c(
                "button",
                {
                  staticClass: "nav-button prev-button",
                  attrs: { type: "button", disabled: "" },
                },
                [
                  _c("i", { staticClass: "md-icon" }, [_vm._v("arrow_back")]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.previousButtonText || "Geri") +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showNextButton
            ? _c(
                "button",
                {
                  staticClass: "nav-button next-button",
                  attrs: { type: "button", disabled: "" },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.nextButtonText || "Devam") +
                      "\n            "
                  ),
                  _c("i", { staticClass: "md-icon" }, [
                    _vm._v("arrow_forward"),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }